import styled from 'styled-components';
import ColorSF2 from '../../../styles/common/ColorSF2';

export const MainBlock = styled.div`
  height: 50px;
  flex: 0 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: ${ColorSF2.paleBlue};
  padding: 0 10px;
  @media (max-height: 530px) {
    height: 30px;
  }
`;

export const ContentsBlock = styled.div`
  height: '100%';
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const ContentsTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-weight: bold;
`;
